export default __webpack_public_path__ + "static/media/photo--sm--111.1897c208.jpg";